import { NgModule } from '@angular/core';
import { CombinedDateTimeRangeComponent } from './combined-date-time-range.component';
import { DateModule } from '../../date.module';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [CombinedDateTimeRangeComponent],
  imports: [DateModule, IntrackFeatureModule, TranslateModule, SvgIconModule],
  exports: [CombinedDateTimeRangeComponent],
})
export class CombinedDateTimeRangeModule {}
